import React from 'react';

import FilterBuilder from '../common/FilterBuilder';
import FilterChips from '../common/FilterChips';
import BuilderStep from './BuilderStep';
import FieldMessage from './FieldMessage';
import QueryRefusalPick from '../items/QueryRefusalPick';

/**
 * Step 5, Filter: which of the card's items the chart counts — the list's
 * own filter controls (`FilterBuilder` and `FilterChips`, with the list's
 * check of every value that has an id behind it), over the chart's card.
 * `me` is the person looking at the chart, so one chart can say "my open
 * jobs" for everyone. Applied, the filter is the spec's `filter`.
 */
export default function FilterStep({ draft, fields, collectionId, onFilter, messagesFor, step, elementRefusal = null, onElementPick = null, onElementRepick = null }) {
	return (
		<BuilderStep step='filter' number={5} title='Filter' {...step}>
			<div className='chart-builder__filter'>
				<FilterBuilder
					fields={fields}
					query={draft.filter || ''}
					onApply={(text) => onFilter(text || '')}
					collectionId={collectionId}
					scopeKey={collectionId ? `chart:${collectionId}` : null}
					emptyText='No conditions yet — the chart counts every item of its card.'
					placeholder='status = open and created > -3mo'
				/>
				{draft.filter ? (
					<FilterChips query={draft.filter} fields={fields} onChange={(text) => onFilter(text || '')} className='list-filter__chips chart-builder__chips' />
				) : (
					<span className='chart-builder__hint'>No filter: every item of the card counts.</span>
				)}
			</div>
			<FieldMessage messages={messagesFor('filter')} id='chart-builder-filter-messages' />
			{/* An element the filter could mean several of, on the chart's card
			    or a card beneath it (element ids step 3): the person picks
			    one, or any of these cards, and the chart is asked again. */}
			<QueryRefusalPick inline refusal={elementRefusal} onPick={value => onElementPick && onElementPick(value)} onRepick={onElementRepick} />
		</BuilderStep>
	);
}
